import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import {LocalizationProvider} from "@mui/x-date-pickers-pro";
import {AdapterDayjs} from "@mui/x-date-pickers-pro/AdapterDayjs";

import dayjs from "dayjs";
import "dayjs/locale/el";

import {enqueueSnackbar} from "notistack";
import {useTranslation} from "react-i18next";

import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper.jsx";
import {muiDatePickersLocales} from "../../helpers/mui/muiLocales";
import useUserAction from "../../hooks/user/useUserAction";
import useUserData from "../../hooks/user/useUserData";
import {PAGE_LOGIN} from "../../locales/pages/namespaces";

import UnauthenticatedRouter from "../../routers/unauthenticatedRouter.jsx";
import Content from "./content.jsx";

import Header from "../../components/app/layout/header/header";
import Footer from "../../components/app/layout/footer/footer";
import CookieBanner from "../../components/general/cookies/cookiesBanner";
import CookieSettingsDialog from "../../components/general/cookies/cookieSettingDialog";

const Main = () => {
    const {isLoggedIn, language, loading, message} = useUserData();
    const {t} = useTranslation(PAGE_LOGIN);
    dayjs.locale(language);
    const {getUserPermissions, getUserDetails, setUserMessage} =
        useUserAction();
    const {i18n} = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language, i18n]);

    useEffect(() => {
        if (isLoggedIn) {
            getUserPermissions();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    // useEffect(() => {
    // 	if (isLoggedIn) {
    // 		 getUserDetails()
    // 	}
    // }, [getUserDetails, isLoggedIn])

    useEffect(() => {
        if (message) {
            enqueueSnackbar(t(message?.text), {
                variant: message?.variant,
                autoHideDuration: null,
            });
            setUserMessage(null);
        }
    }, [message, setUserMessage, t]);

    if (!isLoggedIn)
        return (
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                localeText={muiDatePickersLocales(language)}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "100dvh",
                        bgcolor: "#F0F0F0",
                        boxSizing: "border-box",
                    }}
                >
                    <Header onCartClick={() => { /* noop for unauthenticated */
                    }}/>
                    <Box sx={{width: "100%", display: "flex"}}>
                        <Box component="main"
                             sx={{
                                 flexGrow: 1,
                                 pt: {xs: "10px", md: "40px"},
                                 px: 0,
                                 mt: 2,
                                 boxSizing: "border-box",
                                 width: "100%",
                             }}
                        >
                            <Toolbar variant="dense"/>
                            <Box>
                                <UnauthenticatedRouter/>
                                <Footer/>
                                <CookieBanner/>
                                <CookieSettingsDialog/>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </LocalizationProvider>
        );

    return (
        <SkeletonLoaderWrapper loading={loading}>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                localeText={muiDatePickersLocales(language)}
            >
                <Content/>
                <CookieBanner/>
                <CookieSettingsDialog/>
            </LocalizationProvider>
        </SkeletonLoaderWrapper>
    );
};

export default Main;
